"use strict";
var ComponentStore = {
    store: new Map(),
    /**
     * Registers a new component based on its generated type ID
     * Automatically called by @Attributes
     */
    register: function (componentType) {
        this.store.set(componentType.getTypeName(), componentType);
    },
    /**
     * Retrieves the component for the given type name.
     */
    get: function (typeName) {
        return this.store.get(typeName);
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ComponentStore;

//# sourceMappingURL=ComponentStore.js.map
